import Screen from "../lib/Screen";

import * as PIXI from "pixi.js";
import gsap from "gsap";

import ServiceLocator from "../ServiceLocator";
import Button from "../lib/Button";
import Utils from "../Utils";
import Session, { game_type } from "../Session";
import CreateProfilePopup from "./popup/CreateProfilePopup";
import MathcMakingPopup from "./popup/MatchMakingPopup";
import { screen_type } from "../state/GameState";
import HostPrivateRoomPopup from "./popup/HostPrivateRoomPopup";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction } from "../lib/game_snacks/ILiveMultiplayer";
import Settings from "./Settings";
import TutorialPopup from "./popup/TutorialPopup";
import GuestPrivateRoomPopup from "./popup/GuestPrivateRoomPopup";
import { game_event_type } from "../service/MultiplayerEventManager";
import OfflineRoomPopup from "./popup/OfflineRoomPopup";
import LevelUpPopup from "./popup/LevelUpPopup";
import YouWinPopup from "./popup/YouWinPopup";
import YouLosePopup from "./popup/YouLosePopup";
import DrawPopup from "./popup/DrawPopup";
import Player from "./game/Player";
import Popup from "../lib/Popup";
import { track_id } from "../service/AudioManager";
import SpriteMaskAnim from "../lib/SpriteMaskAnim";
import { Profile } from "../lib/game_snacks/IUser";
import HandDevicePopup from "./popup/HandDevicePopup";


export default class LobbyScreen extends Screen
{
    // #region Attributes //

    // private:

    private _profileAvatar: PIXI.Sprite = null;
    private _profileTitle: PIXI.Text = null;
    private _exclamationIcon: PIXI.Sprite = null;
    private _matchMakingPopup: MathcMakingPopup = null;
    private _settings: Settings = null;
    private _xpBarMask: PIXI.Graphics = null;

    // TEST:
    private _testPopup: Popup = null;
    private _blackBg: PIXI.Graphics = null;
    private _bgAnim: PIXI.AnimatedSprite = null;
    private _spriteMaskAnim: SpriteMaskAnim = null;

    // #endregion //


    // #region Methods //

    // public:

    public constructor()
    {
        super();
    }

    public onEnter( params: any = null ): void
    {
        super.onEnter();

        let bg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_bg.texture );
        bg.anchor.set( 0.5 );
        bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( bg );

        let hudBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_user_hud_base.texture);
        hudBase.anchor.set( 0.5 );
        hudBase.position.set( 168, 72 + 16 );
        this._root.addChild( hudBase );
        //
        // V2:
        /*let xpBar: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_xp_bar.texture);
        xpBar.position.set( hudBase.x - hudBase.texture.width * 0.5 + 1, hudBase.y - hudBase.texture.height * 0.5 + 38 );
        this._root.addChild( xpBar );
        //
        this._xpBarMask = new PIXI.Graphics();
        this._xpBarMask.position.copyFrom( xpBar.position );
        this._xpBarMask.beginFill( 0xff3300 );
        this._xpBarMask.drawRect( 0, 0, xpBar.width, xpBar.height );
        this._xpBarMask.endFill();
        const kXpToNextLevel: number = Utils.findXpToNextLevel( ServiceLocator.saved.data.level );
        this._xpBarMask.scale.x = ServiceLocator.saved.data.level < 99 ? Math.min( ServiceLocator.saved.data.xp / kXpToNextLevel, 1 ) : 1;
        this._root.addChild( this._xpBarMask );
        xpBar.mask = this._xpBarMask;
        //
        let levelBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_level_base.texture);
        levelBase.anchor.set( 0.5 );
        levelBase.position.set( hudBase.x + 117, hudBase.y + 11 );
        this._root.addChild( levelBase );
        //
        let levelValue: PIXI.Text = new PIXI.Text( ServiceLocator.saved.data.level.toString(), { fontSize: 50, fontFamily: "college_tm_regular", fill: 0x192f62, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        levelValue.anchor.set( 0.5 );
        levelValue.y = 2;
        levelBase.addChild( levelValue );
        //
        let xpValue: PIXI.Text = new PIXI.Text( ServiceLocator.saved.data.level < 99 ? ServiceLocator.saved.data.xp.toString() + "/" + kXpToNextLevel.toString() : "MAX LEVEL", { fontSize: 34, fontFamily: "college_tm_regular", fill: 0x000000, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
        xpValue.anchor.set( 0.5 );
        xpValue.position.set( hudBase.x - 5, hudBase.y + 20 );
        this._root.addChild( xpValue );*/
        //
        this._profileAvatar = new PIXI.Sprite( Session.i.profile ? PIXI.Texture.from( Session.i.profile.avatar.src ) : ServiceLocator.resources.avatar_you.texture );
        this._profileAvatar.anchor.set( 0.5 );
        if ( this._profileAvatar.texture.valid ) 
        {
            this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width );
        } 
        else 
        {
            this._profileAvatar.texture.baseTexture.on( "loaded", () => {
                this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width ); } );
        }
        this._profileAvatar.position.set( hudBase.x - 109, hudBase.y - 9 );
        this._root.addChild( this._profileAvatar );
        //
        let profileBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_avatar_base.texture );
        profileBase.anchor.set( 0.5 );
        profileBase.position.copyFrom( this._profileAvatar.position );
        this._root.addChild( profileBase );
        //
        this._profileTitle = new PIXI.Text( Session.i.profile ? Session.i.profile.username.prefix : "YOU", { 
            fontSize: 30, 
            fontFamily: "teko_regular", 
            fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 4,
            dropShadow: true,
            dropShadowAngle: 2,
            dropShadowColor: "#ffffff",
            dropShadowDistance: 2,
            lineJoin: "round"
        } );
        this._profileTitle.anchor.set( 0, 1 );
        this._profileTitle.position.set( hudBase.x - 53, hudBase.y + 1 );
        this._root.addChild( this._profileTitle );

        let title: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.game_logo.texture );
        title.anchor.set( 0.5, 0 );
        title.scale.set( 0.8 ); 
        //title.position.set( ServiceLocator.app.width * 0.5, 342 - 220 ); // V2:
        title.position.set( ServiceLocator.app.width * 0.5, 342 - 200 ); 
        this._root.addChild( title );

        // TEST:
        title.interactive = true;
        title.on( "pointertap", () => {
            ServiceLocator.saved.data.level = 99;
            ServiceLocator.saved.data.ownedBoards = [ 
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9,
                10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
                20, 21, 22, 23, 24, 25, 26, 27, 28, 29,
                30, 31, 32, 33, 34, 35, 36, 37, 38, 39,
                40, 41, 42, 43, 44, 45, 46, 47, 48, 49 ];
             ServiceLocator.saved.data.ownedDarts = ServiceLocator.saved.data.ownedBoards;
        } );
        //

        let playBtn: Button = new Button( { on: "lobby_button_mode_classic", pressed: "lobby_button_mode_classic_pressed" } );
        playBtn.anchor.set( 0.5 );
        //playBtn.scale.set( 0.9 ); // V2:
        playBtn.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height - playBtn.height * 0.5 - 330 ); 
        //playBtn.position.set( ServiceLocator.app.width * 0.5, 501 + 130 ); // V2:
        this._root.addChild( playBtn );
        playBtn.on( "pointertap", this._onPlayClassicOnlineBtn_Click, this );

        // V2:
        /*playBtn = new Button( { on: "lobby_button_mode_offline", pressed: "lobby_button_mode_offline_pressed" } );
        playBtn.anchor.set( 0.5 );
        playBtn.scale.set( 0.9 );
        playBtn.position.set( playBtn.width * 0.5 + 50, 797 + 70 ); 
        this._root.addChild( playBtn );
        playBtn.on( "pointertap", this._onPlayOfflineBtn_Click, this );*/

        playBtn = new Button( { on: "lobby_button_mode_w-friens", pressed: "lobby_button_mode_w-friens_pressed" } );
        playBtn.anchor.set( 0.5 );
        //playBtn.scale.set( 0.9 ); // V2:
        //playBtn.position.set( 475, 809 );
        playBtn.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height - playBtn.height * 0.5 - 80 );
        //playBtn.position.set( ServiceLocator.app.width - playBtn.width * 0.5 - 50, 809 + 70 ); // V2:
        this._root.addChild( playBtn );
        playBtn.on( "pointertap", this._onPrivateGameBtn_Click, this );

        // V2:
        /*let shopBtn: Button = new Button( { on: "lobby_button_shop", pressed: "lobby_button_shop_pressed" } );
        shopBtn.scale.set( 0.8 );
        shopBtn.anchor.set( 0.5 );
        shopBtn.position.set( ServiceLocator.app.width - shopBtn.width * 0.5 - 10, ServiceLocator.app.height - shopBtn.height * 0.5 - 10 );
        this._root.addChild( shopBtn );
        shopBtn.on( "pointertap", this._onShopBtn_Click, this );

        if ( ServiceLocator.saved.data.isShopBoardsUpdated || ServiceLocator.saved.data.isShopDartsUpdated )
        {
            this._exclamationIcon = new PIXI.Sprite( ServiceLocator.resources.lobby_icon_exclamation.texture );
            this._exclamationIcon.scale.set( 0.8 );
            this._exclamationIcon.anchor.set( 0.5 );
            this._exclamationIcon.position.set( 587 + 20, 1006 + 20 );
            this._root.addChild( this._exclamationIcon );
        }*/

        this._settings = new Settings();
        this._settings.init( false );
        this._settings.position.set( 592, 7 + 16 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );

        // TODO: This situation should not happen. 
        /*if ( Session.i.isInvite && !Session.i.profile )
        {
            Session.i.isInvite = false;

            let createProfilePopup: CreateProfilePopup = new CreateProfilePopup();
            createProfilePopup.onEnter();
            createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
        }*/

        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );

        if ( params )
        {
            if ( params.isPlayerLeft )
            {
                Utils.showMessagePopup( "Your opponent left the game." );
            }
            else if ( params.isPlay )
            {
                if ( params.gameType == game_type.CLASSIC_MATCHMAKING )
                {
                    this._onPlayClassicOnlineBtn_Click();
                }
                else
                {
                    this._onPlay301OnlineBtn_Click();
                }
            }
            else if ( params.isPlayPrivate )
            {
                if ( !params.isPrivateHost )
                {
                    Utils.showMessagePopup( "The host left the room." );
                }
                else
                {
                    for ( let i: number = Session.i.room.length - 1; i >= 0; --i )
                    {
                        Session.i.room[ i ].isReady = false;
                    }
                    if ( Session.i.profile.uid == Session.i.room[ 0 ].uid )
                    {
                        Session.i.room[ 0 ].isReady = true;
                        while ( Session.i.roomEvents.length > 0 )
                        {
                            const kRoomEvent: LiveEventData = Session.i.roomEvents.shift();
                            if ( !kRoomEvent.type )
                            {
                                const kPayload: any = JSON.parse( kRoomEvent.payload );
                                if ( kPayload.type == game_event_type.JOINED_PRIVATE_ROOM )
                                {
                                    const kProfileUid: string = JSON.parse( kRoomEvent.payload ).uid;
                                    for ( let profile of Session.i.room )
                                    {
                                        if ( profile.uid == kProfileUid )
                                        {
                                            profile.isReady = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        let privateRoomPopup: HostPrivateRoomPopup = new HostPrivateRoomPopup();
                        privateRoomPopup.url = Session.i.privateRoomUrl;
                        privateRoomPopup.gameType = Session.i.gameType;
                        privateRoomPopup.onEnter();
                        privateRoomPopup.onClosed.add( this._onHostPrivateRoomPopup_Closed, this );
                        privateRoomPopup.onGameStarted.add( this._onHostPrivateRoomPopup_GameStarted, this );
                        //
                        privateRoomPopup.checkPrivateRoomReady();
                    }
                    else
                    {
                        while ( Session.i.roomEvents.length > 0 )
                        {
                            const kRoomEvent: LiveEventData = Session.i.roomEvents.shift();
                            if ( !kRoomEvent.type )
                            {
                                const kPayload: any = JSON.parse( kRoomEvent.payload );
                                if ( kPayload.type == game_event_type.PRIVATE_GAME_TYPE_UPDATED )
                                {
                                    Session.i.gameType = kPayload.gameType;
                                }
                            }
                        }
                        let privateRoomPopup: GuestPrivateRoomPopup = new GuestPrivateRoomPopup();
                        privateRoomPopup.gameType = Session.i.gameType;
                        privateRoomPopup.onEnter();
                        privateRoomPopup.onClosed.add( this._onGuestPrivateRoomPopup_Closed, this );
                        privateRoomPopup.onGameStarted.add( this._onGuestPrivateRoomPopup_GameStarted, this );
                    }
                }
            }
            else if ( params.isPlayOffline )
            {
                let offlineRoomPopup: OfflineRoomPopup = new OfflineRoomPopup();
                offlineRoomPopup.gameType = params.gameType;
                offlineRoomPopup.onEnter();
                offlineRoomPopup.onClosed.add( this._onOfflineRoomPopup_Closed, this );
                offlineRoomPopup.onGameStarted.add( this._onOfflineRoomPopup_GameStarted, this );
            }
            else if ( params.isKicked )
            {
                Utils.showMessagePopup( "Oops! You have been kicked from the game due to inactivity." );
            }
        }

        // TEST:
        /*this._blackBg = new PIXI.Graphics();
        this._blackBg.beginFill( 0x000000 );
        this._blackBg.drawRect( 0, 0, ServiceLocator.app.safeAreaWidth, ServiceLocator.app.safeAreaHeight );
        this._blackBg.endFill();
        this._blackBg.position.set( -ServiceLocator.app.safeAreaMarginX, -ServiceLocator.app.safeAreaMarginY );
        this._root.addChild( this._blackBg );

        let testBg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.gp_bg_9.texture );
        testBg.anchor.set( 0.5 );
        testBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( testBg );
        //
        this._spriteMaskAnim = new SpriteMaskAnim( Utils.createTexArray( "gp_mask_bg_", 9 ) );
        this._spriteMaskAnim.fps = 30;
        this._spriteMaskAnim.init();
        this._spriteMaskAnim.anchor.set( 0.5 );
        this._spriteMaskAnim.position.copyFrom( testBg );
        this._spriteMaskAnim.onCompleted.add( () => { 
            testBg.mask = null;

            this._spriteMaskAnim.parent.removeChild( this._spriteMaskAnim );
            this._spriteMaskAnim.destroy();
            this._spriteMaskAnim = null;

            window.setTimeout( () => {
                testBg.visible = false;

                this._bgAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "gp_bg_", 10 ) );
                this._bgAnim.autoUpdate = false;
                this._bgAnim.animationSpeed = 30;
                this._bgAnim.loop = false;
                this._bgAnim.anchor.set( 0.5 );
                this._bgAnim.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
                this._root.addChild( this._bgAnim );
                this._bgAnim.play();
            }, 2000 );
        } );
        this._root.addChild( this._spriteMaskAnim );

        testBg.mask = this._spriteMaskAnim;

        Session.i.profile = { username: { prefix: "Test", suffix: "" }, avatar: { src: "avatar_0", alt: "" } };
        /*let testPopup: LevelUpPopup = new LevelUpPopup();
        testPopup.onEnter();*/
        //
        /*Session.i.room = [
            { username: { prefix: "Test", suffix: "" }, avatar: { src: "avatar_0", alt: "" } },
            { username: { prefix: "Test", suffix: "" }, avatar: { src: "avatar_1", alt: "" } }
        ];
        let testPopup: DrawPopup = new DrawPopup();
        testPopup.isRematchAccepted = false;
        let arrPlayer: Array<Player> = [ new Player(), new Player() ];
        arrPlayer[ 0 ].id = 0;
        arrPlayer[ 0 ].score = 999;
        arrPlayer[ 1 ].id = 1;
        arrPlayer[ 1 ].score = 999;
        testPopup.players = arrPlayer;
        testPopup.onEnter();
        this._testPopup = testPopup;*/

        /*let testPopup: HandDevicePopup = new HandDevicePopup();
        testPopup.playerIndex = 0;
        testPopup.onEnter();
        this._testPopup = testPopup;*/
    }

        private _onPlayClassicOnlineBtn_Click(): void
        {
            if ( Session.i.profile )
            {
                Session.i.gameType = game_type.CLASSIC_MATCHMAKING;

                this._matchMakingPopup = new MathcMakingPopup();
                this._matchMakingPopup.onEnter();
                this._matchMakingPopup.onClosed.add( this._onMatchMakingPopup_Closed, this );
                this._matchMakingPopup.onGameStarted.add( this._onMatchMaking_GameStarted, this );
            }
            else
            {
                this._root.interactiveChildren = false;
                window.GameSnacks.user.requestProfile()
                    .then( 
                        ( profile: Profile ) => { 
                            this._root.interactiveChildren = true;
                                                
                            if ( profile )
                            {
                                Session.i.profile = profile;

                                this._onProfileCreated( game_type.CLASSIC_MATCHMAKING );
                            }
                            else
                            {
                                let createProfilePopup: CreateProfilePopup = new CreateProfilePopup();
                                createProfilePopup.gameType = game_type.CLASSIC_MATCHMAKING;
                                createProfilePopup.onEnter();
                                createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
                            }
                        }
                    )
                    .finally( () => { this._root.interactiveChildren = true; } );
            }
        }

            private _onMatchMakingPopup_Closed( popup: MathcMakingPopup ): void
            {
                popup.onLeave();
                this._matchMakingPopup = null;
            }

            private _onMatchMaking_GameStarted( popup: MathcMakingPopup ): void
            {
                popup.onLeave();
                this._matchMakingPopup = null;

                this._onCompleted.dispatch( screen_type.GAMEPLAY );
            }

            private _onCreateProfilePopup_Closed( popup: CreateProfilePopup, gameType: game_type ): void
            {
                popup.onLeave();

                if ( gameType !== null )
                {
                    this._onProfileCreated( gameType );
                }
            }

            private _onProfileCreated( selGameType: game_type ): void
            {
                this._profileAvatar.texture = PIXI.Texture.from( Session.i.profile.avatar.src );
                if ( this._profileAvatar.texture.valid ) 
                {
                    this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width );
                } 
                else 
                {
                    this._profileAvatar.texture.baseTexture.on( "loaded", () => {
                        this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width ); } );
                }
                this._profileTitle.text = Session.i.profile.username.prefix;

                if ( selGameType == game_type.CLASSIC_MATCHMAKING )
                {
                    this._onPlayClassicOnlineBtn_Click();
                }
                else
                {
                    this._onPrivateGameBtn_Click();
                }
            }

        private _onPlay301OnlineBtn_Click(): void
        {
            if ( Session.i.profile )
            {
                Session.i.gameType = game_type.POINTS_MATCHMAKING;

                this._matchMakingPopup = new MathcMakingPopup();
                this._matchMakingPopup.onEnter();
                this._matchMakingPopup.onClosed.add( this._onMatchMakingPopup_Closed, this );
                this._matchMakingPopup.onGameStarted.add( this._onMatchMaking_GameStarted, this );
            }
            else
            {
                let createProfilePopup: CreateProfilePopup = new CreateProfilePopup();
                createProfilePopup.gameType = game_type.POINTS_MATCHMAKING;
                createProfilePopup.onEnter();
                createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
            }
        }

        private _onPlayOfflineBtn_Click(): void
        {
            let offlineRoomPopup: OfflineRoomPopup = new OfflineRoomPopup();
            offlineRoomPopup.onEnter();
            offlineRoomPopup.onClosed.add( this._onOfflineRoomPopup_Closed, this );
            offlineRoomPopup.onGameStarted.add( this._onOfflineRoomPopup_GameStarted, this );
        }

            private _onOfflineRoomPopup_Closed( popup: OfflineRoomPopup ): void
            {
                popup.onLeave();
            }

            private _onOfflineRoomPopup_GameStarted( popup: OfflineRoomPopup, gameType: game_type ): void
            {
                popup.onLeave();

                Session.i.gameType = gameType;

                this._onCompleted.dispatch( screen_type.GAMEPLAY );
            }

        private _onPrivateGameBtn_Click(): void
        {
            if ( Session.i.profile )
            {
                this._root.interactiveChildren = false;

                ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.addOnce( ( presenceEventPromise: Promise<LivePlayerDataEvent> ) => {
                    presenceEventPromise
                        .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                            if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                            {
                                if ( livePlayerDataEvent.isHost )
                                {
                                    Session.i.profile.uid = livePlayerDataEvent.uid;
                                }
                            }
                        } );
                } );
                window.GameSnacks.liveMultiplayer.createRoom()
                    .then( 
                        ( privateRoomUrl: string ) => { 
                            this._root.interactiveChildren = true;

                            Session.i.room = [ Session.i.profile ];

                            let privateRoomPopup: HostPrivateRoomPopup = new HostPrivateRoomPopup();
                            privateRoomPopup.url = privateRoomUrl;
                            privateRoomPopup.onEnter();
                            privateRoomPopup.onClosed.add( this._onHostPrivateRoomPopup_Closed, this );
                            privateRoomPopup.onGameStarted.add( this._onHostPrivateRoomPopup_GameStarted, this );
                        },
                        () => { this._root.interactiveChildren = true; }
                    );
            }
            else
            {
                this._root.interactiveChildren = false;
                window.GameSnacks.user.requestProfile()
                    .then( 
                        ( profile: Profile ) => { 
                            if ( profile )
                            {
                                Session.i.profile = profile;

                                this._onProfileCreated( game_type.CLASSIC_PRIVATE );
                            }
                            else
                            {
                                let createProfilePopup: CreateProfilePopup = new CreateProfilePopup();
                                createProfilePopup.gameType = game_type.CLASSIC_PRIVATE;
                                createProfilePopup.onEnter();
                                createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
                            }
                        }
                    )
                    .finally( () => { this._root.interactiveChildren = true; } );
            }
        }

            private _onHostPrivateRoomPopup_Closed( popup: HostPrivateRoomPopup ): void
            {
                popup.onLeave();
            }

            private _onHostPrivateRoomPopup_GameStarted( popup: HostPrivateRoomPopup, gameType: game_type ): void
            {
                popup.onLeave();

                Session.i.gameType = gameType;

                this._onCompleted.dispatch( screen_type.GAMEPLAY );
            }

        private _onGuestPrivateRoomPopup_Closed( popup: GuestPrivateRoomPopup ): void
        {
            popup.onLeave();

            Session.i.room = [];
        }

        private _onGuestPrivateRoomPopup_GameStarted( popup: GuestPrivateRoomPopup, gameType: game_type ): void
        {
            popup.onLeave();

            Session.i.gameType = gameType;

            this._onCompleted.dispatch( screen_type.GAMEPLAY );
        }

        private _onShopBtn_Click(): void
        {
            this._onCompleted.dispatch( screen_type.SHOP );
        }

        private _onProfile_Changed( profile: Profile ): void
        {
            if ( !Session.i.profile )
            {
                Session.i.profile = profile;
            }
            else
            {
                ( Session.i.profile.username as any ) = profile.username;
                ( Session.i.profile.avatar as any ) = profile.avatar;
            }

            this._profileAvatar.texture = PIXI.Texture.from( Session.i.profile.avatar.src );
            if ( this._profileAvatar.texture.valid ) 
            {
                this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width );
            } 
            else 
            {
                this._profileAvatar.texture.baseTexture.on( "loaded", () => {
                    this._profileAvatar.scale.set( 87/this._profileAvatar.texture.width ); } );
            }
            this._profileTitle.text = Session.i.profile.username.prefix;
        }

    public onUpdate( dt: number ): void 
    {
        if ( this._matchMakingPopup )
        {
            this._matchMakingPopup.onUpdate( dt );
        }

        if ( this._testPopup )
        {
            this._testPopup.onUpdate( dt );
        }

        // TEST:
        if ( this._spriteMaskAnim )
        {
            this._spriteMaskAnim.update( dt );
        }
        if ( this._bgAnim )
        {
            this._bgAnim.update( dt );
        }
    }

    public onLeave(): void
    {
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        this._settings.end();
        this._settings = null;

        super.onLeave();
    }

    // #endregion //
}
